import React, {useState, useEffect} from "react";
import StatementGenerate from "../../../../entities/DashboardPage/AccountingModule/StatementGenerate/Home";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";

const StatementGeneratePage = () => {

  const [data,setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [banks, setbanks] = useState()
  const [success, setSuccess] = useState()
  const {showAlert} = useAlert()


  useEffect(() => {
    getAllBanks()
  },[page])
  const getStatementGenerate = async(sort,start, end, account,type) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getStatementGenerate(sort,start, end, account,type);
      if (result?.success) { 
        setData(result?.data);
        setTotal(result?.data?.total);
        showAlert(result?.message,"success")
        setSuccess(result?.success)
        LoaderHelper.loaderStatus(false);
      } else {
        setSuccess(result?.success)
        showAlert(result?.message,"error")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllBanks();
      if (result?.success) {
        setbanks(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };


  const handleDownload = async (start,end,type,bankName,format) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.statementDownload(start,end,type,bankName,format);
      if (!result) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type:"application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${ format}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  return (
    
    <StatementGenerate page={page} banks={banks} success={success} total={total} handleDownload={handleDownload} setPage={setPage} data={data} getStatementGenerate={getStatementGenerate}/>
  )


}

export default StatementGeneratePage;
